"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateDatasetsDataLoaderFactory = void 0;
var DataLoaderAbstractFactory_1 = require("./DataLoaderAbstractFactory");
var DateDatasetsDataLoader = /** @class */ (function () {
    function DateDatasetsDataLoader(workspace) {
        this.workspace = workspace;
    }
    DateDatasetsDataLoader.prototype.getDateDatasets = function (backend) {
        var _this = this;
        if (!this.cachedDateDatasets) {
            this.cachedDateDatasets = backend
                .workspace(this.workspace)
                .catalog()
                .forTypes(["dateDataset"])
                .load()
                .then(function (catalog) { return catalog.dateDatasets(); })
                .catch(function (error) {
                _this.cachedDateDatasets = undefined;
                throw error;
            });
        }
        return this.cachedDateDatasets;
    };
    return DateDatasetsDataLoader;
}());
/**
 * @internal
 */
exports.dateDatasetsDataLoaderFactory = DataLoaderAbstractFactory_1.dataLoaderAbstractFactory(function (workspace) { return new DateDatasetsDataLoader(workspace); });
//# sourceMappingURL=DateDatasetsDataLoader.js.map